import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { Router, RouterLink } from '@angular/router';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export interface PageNotFoundState {
  entityTranslationKey?: string;
}

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [MatCard, MatCardContent, MatCardTitle, MatCardHeader, RouterLink, TranslocoDirective, MatAnchor, MatIcon],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent implements OnInit {
  #router = inject(Router);
  #transloco = inject(TranslocoService);

  message!: string;

  ngOnInit() {
    const state: PageNotFoundState | undefined = this.#router.lastSuccessfulNavigation?.extras.state;
    if (state?.entityTranslationKey) {
      const entityName = this.#transloco.translate(state.entityTranslationKey);
      this.message = this.#transloco.translate('reference.message.entityNotFound', { entity: entityName });
    } else {
      this.message = this.#transloco.translate('reference.message.pageNotFound');
    }
  }
}
